export const MiComponente = () => {
  return (
    <div className="d-none">
    <h1 className="m_hl">hl Este es el Headline Large</h1>
    <h1 className="m_hm">hm Este es el Headline Medium</h1>
    <h1 className="m_hs">hs Este es el Headline Small</h1>
    <h4 className="m_tl">tl Este es el Title Large</h4>
    <h4 className="m_tm">tm Este es el Title Medium</h4>
    <h4 className="m_ts">ts Este es el Title Small</h4>
    <p className="m_bl">bl Este es el Body Large, texto de párrafo grande.</p>
    <p className="m_bm">bm Este es el Body Medium, texto de párrafo mediano.</p>
    <p className="m_bs">bs Este es el Body Small, texto de párrafo pequeño.</p>
  </div>
  );
};
